var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPressure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4889 28.8823C35.0844 26.6599 35.1606 24.3303 34.7118 22.0736C34.2629 19.817 33.3009 17.6939 31.9003 15.8686C30.4997 14.0432 28.6979 12.5645 26.6343 11.5469C24.5708 10.5293 22.3008 10 20 10C17.6992 10 15.4292 10.5293 13.3657 11.5469C11.3021 12.5645 9.50035 14.0432 8.0997 15.8686C6.69905 17.6939 5.73709 19.817 5.28822 22.0736C4.83935 24.3303 4.91562 26.6599 5.51111 28.8823",
    stroke: "#0A0D1F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2762 25.9705C22.0886 27.1528 21.5173 28.9564 20 29.999C18.4828 31.0417 16.5942 30.9285 15.7818 29.7462C14.8154 28.3399 11.2041 19.6774 9.53222 15.6149C9.32823 15.1193 9.9349 14.7024 10.3245 15.0705C13.5176 18.0876 20.3098 24.5642 21.2762 25.9705Z",
    stroke: "#0A0D1F",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10V13.3333",
    stroke: "#0A0D1F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39331 14.3929L11.7503 16.7499",
    stroke: "#0A0D1F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6067 14.3929L28.2497 16.7499",
    stroke: "#0A0D1F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.489 28.8818L31.2692 28.0191",
    stroke: "#0A0D1F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51105 28.8818L8.7308 28.0191",
    stroke: "#0A0D1F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/Pressure.931d27a8.svg";
export { ForwardRef as ReactComponent };